<template>
  <div class="backlog-content" style="margin-top: 10px;overflow: hidden;">
    <div class="backlog-order-positive">
      <!--订单正向-->
      <div class="order-title">
        <div class="order-text">
          <img src="/static/img/index/order-z-icon.png" alt=""/>
          订单正向
        </div>
      </div>
      <div class="backlog-list">
        <div class="backlog-info" ref="infoWidth" v-for="(orderZInfo,zIndex) in orderZList" :key="zIndex"
             :style="zIndex == 3?'margin-right: 0px;':''">
          <div class="backlog-title">
            <div class="title">
              <img :src='imgSrcList[orderZInfo.key]' alt=""/>
              {{ orderZInfo.title }}
            </div>
            <div class="count">{{ orderZInfo.count }}</div>
          </div>
          <div class="backlog-merchant">
            <div :ref="'mySwiperZ'+zIndex" :options="swiperOption" style="height: 100%;">
              <div v-for="(shopInfo,infoIndex) in orderZInfo.data" :key="infoIndex"
                            style="cursor: pointer;overflow-y: auto;">
                <div style="cursor: pointer;overflow-y: auto;height: 80px;" @click.stop="swiperClick((shopInfo.key?shopInfo.key:0)+','+orderZInfo.key)">
                  <div class="backlog-status" v-if="shopInfo['title']">{{ shopInfo['title'] }}：{{
                      shopInfo['count']
                    }}
                  </div>
                  <div class="merchant-info" v-for="(shop,infoIndex) in shopInfo['shopList']" :key="infoIndex">
                    <Tooltip
                      class="item"
                      effect="dark"
                      :content="shop['SHOP_ENAME']"
                      placement="top-start"
                    >
                      <div class="merchant-name">{{ shop["SHOP_ENAME"] }}</div>
                    </Tooltip>
                    <div class="merchant-count">{{ shop["rpt_value"] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="button-prev" v-if="orderZInfo.data.length > 1" class="swiper-button-prev"
                 @click="prev('mySwiperZ'+zIndex)"/>
            <div slot="button-next" v-if="orderZInfo.data.length > 1" class="swiper-button-next"
                 @click="next('mySwiperZ'+zIndex)"/>
          </div>
        </div>
      </div>
    </div>
      <!--订单逆向-->

    <div class="backlog-order-contrary" style="margin-top: 15px;">
      <div class="order-title">
        <div class="order-text">
          <img src="/static/img/index/order-n-icon.png" alt=""/>
          订单逆向
        </div>
      </div>
      <div class="backlog-list">
        <div class="backlog-info" ref="infoWidth" v-for="(orderNInfo,nIndex) in orderNList" :key="nIndex"
             :style="nIndex == 3?'margin-right: 0px;':''">
          <div class="backlog-title">
            <div class="title">
              <img :src='imgSrcList[orderNInfo.key]' alt=""/>
              {{ orderNInfo.title }}
            </div>
            <div class="count">{{ orderNInfo.count }}</div>
          </div>
          <div class="backlog-merchant">
            <div :ref="'mySwiperN'+nIndex" :options="swiperOption" style="height: 100%;">
              <div v-for="(shopInfo,shopIndex) in orderNInfo.data" :key="shopIndex">
                <div style="cursor: pointer;overflow-y: auto;height: 80px;" @click.stop="swiperClick((shopInfo.key?shopInfo.key:0)+','+orderNInfo.key)">
                  <div class="backlog-status" v-if="shopInfo['title']">{{ shopInfo['title'] }}：{{
                      shopInfo['count']
                    }}
                  </div>
                  <div class="merchant-info" v-for="(shop,infoIndex) in shopInfo['shopList']" :key="infoIndex">
                    <Tooltip
                      class="item"
                      effect="dark"
                      :content="shop['SHOP_ENAME']"
                      placement="top-start"
                    >
                      <div class="merchant-name">{{ shop["SHOP_ENAME"] }}</div>
                    </Tooltip>
                    <div class="merchant-count">{{ shop["rpt_value"] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="button-prev" v-if="orderNInfo.data.length > 1" class="swiper-button-prev"
                 @click="prev('mySwiperN'+nIndex)"/>
            <div slot="button-next" v-if="orderNInfo.data.length > 1" class="swiper-button-next"
                 @click="next('mySwiperN'+nIndex)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
import { allData } from './backlogInfo.js'
//引入样式
// import 'swiper/css/swiper.css'
import axios from "axios";

export default {
 /*  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  }, */
  name: "backlog",
  data() {
    return {
      currentDate:"",
      backlogTimeSel: 1,
      backInfoHeigh: 140,
      swiperOption: {
        //显示分页
        pagination: {
          el: '.swiper-pagination'
        },
        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          click: (e) => {
            return false;
          },
        },
        //开启循环模式
        loop: true
      },
      orderZList: [],
      orderNList: [],
      imgSrcList: {
        "ORDER_CONVERSION_FAILED": "/static/img/index/backlog-fail-icon.png",
        "PLATFORM_NOT_DELIVERED": "/static/img/index/backlog-ptwfh-icon.png",
        "WAREHOUSE_NOT_DELIVERED": "/static/img/index/backlog-ckwfh-icon.png",
        "WAREHOUSE_12h_NOT_DELIVERED": "/static/img/index/backlog-timeout-icon.png",
        "REFUND_SUCCESSFUL": "/static/img/index/backlog-tkcg-icon.png",
        "REFUND_ORDER": "/static/img/index/backlog-wwjtk-icon.png",
        "INTERCEPTION_ORDER": "/static/img/index/backlog-ljqj-icon.png",
        "DELIVERED_NOT_COMPLETED": "/static/img/index/backlog-wwj-icon.png"
      }
    }
  },
  mounted() {
    this.initScroll();
    let _zList = [
      {
        "key": "ORDER_CONVERSION_FAILED", "count": 0, "data": [], "title": ""
      },
      {
        "key": "PLATFORM_NOT_DELIVERED", "count": 0, "data": [], "title": ""
      },
      {
        "key": "WAREHOUSE_NOT_DELIVERED", "count": 0, "data": [], "title": ""
      },
      {
        "key": "WAREHOUSE_12h_NOT_DELIVERED", "count": 0, "data": [], "title": ""
      }
    ];
    let _nList = [
      {
        "key": "REFUND_SUCCESSFUL", "count": 0, "data": [], "title": ""
      },
      {
        "key": "REFUND_ORDER", "count": 0, "data": [], "title": ""
      },
      {
        "key": "INTERCEPTION_ORDER", "count": 0, "data": [], "title": ""
      },
      {
        "key": "DELIVERED_NOT_COMPLETED", "count": 0, "data": [], "title": ""
      }
    ];
    for (let i in allData) {
      let _data = allData[i];
      for (let j in _zList) {
        if (_data["key"] == _zList[j]["key"]) {
          _zList[j] = _data;
        }
      }
      for (let j in _nList) {
        if (_data["key"] == _nList[j]["key"]) {
          _nList[j] = _data;
        }
      }
    }
    this.orderZList = _zList;
    this.orderNList = _nList;
    
  },
  methods: {
    swiperClick(_shopInfo){
      _shopInfo = _shopInfo.split(",");
      this.viewHref(_shopInfo);
    },
    initScroll(){
      $(".swiper-slide").on("scroll",function(){
        console.error("aaa");
      });
    },
    viewHref(_values) {
      let _that = this;
    },
    initBackInfoHeight() {
      let _infoWidth = parseInt((window.getComputedStyle(this.$refs.infoWidth).width));
      this.backInfoHeigh = _infoWidth * 140 / 202;
    },
    prev(_mySwiper) {
      this.$refs[_mySwiper][0].$swiper.slidePrev();
    },
    next(_mySwiper) {
      this.$refs[_mySwiper][0].$swiper.slideNext();
    },
  }
}
</script>

<style scoped lang="less">
.backlog-content {
  width: 100%;
}

.order-title {
  position: relative;
  height: 30px;
  display: flex;
  align-items: center;
}

.order-text {
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #111111;
  letter-spacing: 0;
}

.order-text img {
  width: 17px;
  margin-right: 3px;
}

.backlog-time {
  position: absolute;
  right: 0px;
  top: 0px;
}

.backlog-time span {
  display: inline-block;
  height: 26px;
  line-height: 26px;
  font-weight: unset;
  font-size: 12px;
  color: #595959;
  text-align: center;
  border-radius: 2px;
  padding: 0px 10px;
}

.backlogTime-sel {
  background: #0D6FBA;
  border: 1px solid #0D6FBA;
  color: #fff !important;
}

.backlogTime-unsel {
  border: 1px solid #D9D9D9;
  cursor: pointer;
}

.backlog-list {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.backlog-info {
  width: 24%;
  height: 100%;
  border: 1px solid #F0F2F5;
  border-radius: 7px;
  position: relative;
}

.backlog-title {
  padding: 0px 16px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F5F9FC;
}

.backlog-title .title {
  font-size: 12px;
  font-weight: bold;
  color: #111111;
  letter-spacing: 0;
  display: flex;
  align-items: center;
}

.backlog-title .title img {
  width: 13px;
  margin-right: 3px;
  display: inline-block;
}

.backlog-title .count {
  font-size: 18px;
  font-weight: bold;
  color: #111111;
  letter-spacing: 0;
}

.backlog-merchant {
  margin-top: 8px;
  height: 80px;
  overflow-x: hidden;
  overflow-y: auto;
}

.backlog-status {
  font-size: 12px;
  font-weight: bold;
  color: #262626;
  letter-spacing: 0;
  width: 100%;
  padding: 0px 16px;
}

.merchant-info {
  font-size: 10px;
  color: #333333;
  letter-spacing: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 16px;
}
.merchant-name{
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.swiper-button-prev:after {
  font-size: 12px;
  position: absolute;
  left: 4px;
}

.swiper-button-prev {
  top: 90px;
  left: 0px;
  font-size: 12px;
  color: rgba(0, 0, 0, .25);
}

.swiper-button-next:after {
  font-size: 12px;
  position: absolute;
  right: 4px;
}

.swiper-button-next {
  top: 90px;
  right: 0px;
  font-size: 12px;
  color: rgba(0, 0, 0, .25);
}
</style>
